import { render, staticRenderFns } from "./OverdueGroup.vue?vue&type=template&id=0a30e5ee&scoped=true&"
import script from "./OverdueGroup.vue?vue&type=script&lang=js&"
export * from "./OverdueGroup.vue?vue&type=script&lang=js&"
import style0 from "./OverdueGroup.vue?vue&type=style&index=0&id=0a30e5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30e5ee",
  null
  
)

export default component.exports